import React from 'react';
import Nav from '../containers/Nav';
import Title from '../containers/Title';

export default () => (
	<div className="container">
		<div className="col--one">
			<Title />
		</div>
		<div className="col--two">
			<Nav selected={'Contact'}/>
            <p>For all enquiries, please email <a href="mailto: p.thomas@bham.ac.uk">p.thomas@bham.ac.uk</a>.</p>  
            <p>Connect at <a href="https://linkedin.com/in/patricia-thomas-353b19b7">LinkedIn</a>.</p>
            <p>Follow me on <a href="https://twitter.com/PThomas2017">Twitter</a>.</p>
		</div>
	</div>
)


// WEBPACK FOOTER //
// ./src/components/Info.js